import React from 'react';
import thumbnail from './material/thumbnail.jpg';
import cscw2025 from './material/cscw2025.png';

const thingMoji2025 = {
  id: 'thingmoji-2025',
  year: 2025,
  title: <><i>ThingMoji</i>: User-Captured Cut-Outs For In-Stream Visual Communication</>,
  altTitle: 'ThingMoji: User-Captured Cut-Outs For In-Stream Visual Communication',
  authors: [
    { name: 'Erzhen Hu', url: 'https://erzhenh.com/' },
    { name: 'Qian Wan', url: 'https://llewynwan.github.io/' },
    { name: 'Changkong Zhou' },
    { name: 'Md Aashikur Rahman Azim' },
    { name: 'Piaohong Wang' },
    { name: 'Xingyi Hu' },
    { name: 'Yuhan Zeng' },
    { name: 'Zhicong Lu', url: 'https://luzhc.github.io/' },
    { name: 'Seongkook Heo', url: 'https://seongkookheo.com/' },
  ],
  thumbnail,
  keywords: ['Live-Streaming', 'Video-Mediated Communication', 'One-To-Many Communication', 'Shared Narrative'],
  awards: [],
  links: [
    { label: '[Paper]', url: 'https://dl.acm.org/doi/10.1145/3757676' },
    { label: '[GitHub]', url: 'https://github.com/ecruhue/thingmoji' },
  ],
  venue: 'ACM CSCW 2025',
  fullVenue: 'The ACM Conference on Computer-Supported Cooperative Work and Social Computing',
  venueLogo: cscw2025,
};

export default thingMoji2025;